let $ = jQuery;

import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

let AnimationManager = require('../utilities/animation-manager');

let idHeader = '#intro';

class HomepageHeader extends AnimationManager {

  constructor() {
    super();

    $('.announcement-bug__trigger').on('click', () => {
      this.handleClick();
    });

    $('.announcement-bug__close').on('click', () => {
      this.handleClose();
    });
  }

  handleClick() {
    $('.announcement-bug__content').toggleClass('announcement-bug__content--visible');
  }

  handleClose() {
    $('.announcement-bug__content').removeClass('announcement-bug__content--visible');
  }

  createScenes() {

    let h = $('#intro').height() * .8;
    let duration = $('#intro').height() * .2;

    let sceneScroll = new ScrollMagic.Scene({
        triggerElement: '#intro',
        offset: h,
        duration: duration
      })
      .setTween('#homepage-header-scroll', {
        opacity: 0,
        bottom: '20px',
        ease: Power1.easeInOut
      }) // trigger a TweenMax.to tween
      // .addIndicators({name: 'scroll in (duration: 100px)'}) // add indicators (requires plugin)
      .addTo(this.controller);

    let sceneContent = new ScrollMagic.Scene({
        triggerElement: '#intro',
        offset: h,
        duration: duration
      })
      .setTween('#homepage-header-content', {
        top: '40%',
        ease: Power1.easeInOut
      }) // trigger a TweenMax.to tween
      // .addIndicators({name: 'content in (duration: 100px)'}) // add indicators (requires plugin)
      .addTo(this.controller);
  }

  destroyScenes() {
    super.destroyScenes();
    $('#homepage-header-scroll').removeAttr('style');
    $('#homepage-header-content').removeAttr('style');
  }

}

function init() {
  if($(idHeader).length) {
    let homepageHeader = new HomepageHeader();
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function (context, settings) {
      init();
    }
  };

}
